import { render, staticRenderFns } from "./ProductRequirements.vue?vue&type=template&id=552f2b12&"
import script from "./ProductRequirements.vue?vue&type=script&lang=js&"
export * from "./ProductRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports